
import React, { useState, useEffect, useCallback } from 'react';
import Popup from 'reactjs-popup';
import { FaPlus } from 'react-icons/fa';
import { Container, Alert } from "react-bootstrap";
import { postToApi, getFromApi } from '../utilities/NetUtilities';
import { buildUrl } from '../helper/handler';
import Nota from './Nota';
import ElencoNote from './ElencoNote';
import EliminaNota from './EliminaNota';
import FiltroNote from './FiltroNote';


function GestioneNote() {

    const [message, setMessage] = useState([]);
    const [note, setNote] = useState([]);
    const [lavoratori, setLavoratori] = useState({});
    const [sedi, setSedi] = useState({});
    const [refresh, setRefresh] = useState(false);
    const [filtro, setFiltro] = useState({
        tutte: false,
        inizio: "",
        fine: "",
        tiponota: "",
        lavoratore: "",
        sedi: []
    });

    const setMessageFromApi = useCallback((data) => {
        setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }]);
    }, []);

    useEffect(() => {
        function getNote() {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
            if (organizzazioneMap) {
                const setNoteFromApi = (data) => {
                    setNote(data.note)
                    setLavoratori(data.lavoratori)
                    setSedi(data.sedi)
                };
                const urlNote = buildUrl('note', {
                    tutte: filtro.tutte,
                    inizio: filtro.inizio,
                    fine: filtro.fine,
                    tiponota: filtro.tiponota,
                    lavoratore: filtro.lavoratore,
                    sedi: filtro.sedi,
                    organizzazione: organizzazioneMap.nome,
                    tipo: organizzazioneMap.tipo
                });
                getFromApi(urlNote, setNoteFromApi, setMessageFromApi);
            }
        }
        getNote();
    }, [refresh, filtro, setMessageFromApi])

    const getPopup = (trigger, nota, index, action) => {
        return (
            <Popup
                trigger={trigger}
                position="bottom center"
                id={`nota-${index}`}
                modal>{
                    close =>
                        <Nota
                            setMessageEsterno={setMessage}
                            nota={nota}
                            close={close}
                            action={action}
                            lavoratoriMap={lavoratori}
                            sediMap={sedi}
                        />
                }
            </Popup>)
    }


    const okAddNotaAction = (data) => {
        setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }]);
        setRefresh(!refresh);
    };

    const okEditNotaAction = (data) => {
        setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }]);
        setRefresh(!refresh)
    };

    const addNota = (nota, close) => {
        setMessage([])
        const url = buildUrl('addNota');
        postToApi(url, nota, okAddNotaAction, setMessageFromApi);
        close();
    }

    const editNota = (nota, close) => {
        setMessage([])
        const url = buildUrl('editNota');
        postToApi(url, nota, okEditNotaAction, setMessageFromApi);
        close();
    }

    const printEdit = (trigger, nota, index) => {
        return getPopup(trigger, nota, index, editNota)
    }

    const deleteNota = (nota, close) => {
        setMessage([])
        const urlElimina = buildUrl('eliminaNota');
        postToApi(urlElimina, { id: nota.id }, setMessageFromApi, setMessageFromApi);
        setRefresh(!refresh)
        close();
    }

    const openDelete = (trigger, nota) => {
        return (
            <Popup
                trigger={trigger}
                position="bottom center"
                id={`eliminanota`}
                modal>{
                    close =>
                        <EliminaNota
                            setMessage={setMessage}
                            nota={nota}
                            close={close}
                            action={deleteNota}
                        />
                }
            </Popup>)
    }

    const filtra = (tutte, lavoratore, tipo, sedi, inizio, fine) => {
        setMessage([]);
        setFiltro({
            tutte: tutte,
            lavoratore: lavoratore,
            tiponota: tipo,
            sedi: sedi,
            inizio: inizio,
            fine: fine
        })

    }

    return (
        <div className='main' role="main">
            <div>
                <h1 className="d-flex justify-content-center inEvidenza" id="title_home">Gestione Note</h1>
                {
                    message && message.map((data, key) => (
                        <Alert variant={data.tipo} id="message" key={key}>
                            {data.descrizione}
                        </Alert>
                    ))
                }
                <Container>
                    <FiltroNote action={filtra} setMessageFromApi={setMessageFromApi}></FiltroNote>
                    {getPopup(<span id="aggiungi-nota" className="actionIcon"><FaPlus className="space" title='aggiungi nota' /></span>, null, "nuova", addNota)}
                    <ElencoNote note={note} lavoratori={lavoratori} sedi={sedi} edit={printEdit} openDelete={openDelete} />
                </Container>
            </div>
        </div>)
}



export default GestioneNote;